export default "/imgs/copy_icon.png"